import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetSchedules = async (options = {}) => {
  try {
    const apiConfig = getApiConfig();

    const { type, visibleRange, institutionId, scheduleId, selectedDate } =
      options;

    const params = {
      tripLegsArray: false,
    };

    if (scheduleId) {
      params.scheduleId = scheduleId;
    } else {
      if (Array.isArray(type) && type.length > 0) {
        params.tripType = type;
      }
      if (selectedDate) {
        params.selectedDate = selectedDate;
      } else {
        if (visibleRange?.startDate) params.startDate = visibleRange.startDate;
        if (visibleRange?.endDate) params.endDate = visibleRange.endDate;
      }
      if (institutionId) params.institutionId = institutionId;
    }

    const result = await axios.get(`${apiConfig.baseURL}/schedules`, {
      headers: apiConfig.headers,
      params,
    });

    return result;
  } catch (error) {
    console.error("Error fetching schedules:", error);
    return error;
  }
};

export const APIGetFamilySchedules = async ({
  familyId,
  startDate,
  endDate,
  institutionId,
} = {}) => {
  try {
    const apiConfig = getApiConfig();

    const params = {};
    if (familyId) params.familyId = familyId;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (institutionId) params.institutionId = institutionId;

    const result = await axios.get(`${apiConfig.baseURL}/family-schedules`, {
      headers: apiConfig.headers,
      params,
    });

    return result;
  } catch (error) {
    console.error("Error fetching family schedules:", error);
    return error;
  }
};

export const APICreateSchedule = async (
  schedulingData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const formattedData = {
      ...schedulingData,
      institutionId: institutionId,
    };

    const result = await axios.post(
      `${apiConfig.baseURL}/schedules`,
      formattedData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error creating schedule:", error);
    return error;
  }
};

export const APIUpdateSchedule = async (scheduleData, setLoading, institutionId, token) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}/schedules/`,
      scheduleData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating schedules:", error);
    return error;
  }
};

export const APIDeleteSchedule = async (scheduleId, setLoading, institutionId, token) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.delete(`${apiConfig.baseURL}/schedules`, {
      headers: {
        ...apiConfig.headers,
        token: token,
        institutionId: institutionId,
      },
      data: { scheduleId: scheduleId },
    });
    return result;
  } catch (error) {
    console.error("Error deleting schedules:", error);
    return error;
  } finally {
    setLoading(false);
  }
};
